import { useAuth0 } from "@auth0/auth0-react"
import React, { useMemo } from "react"
import { isAdmin } from "../../../../Utils/util"
import BifrostGridForm from "../../../BifrostElementComponent/BifrostGridForm/BifrostGridForm"
import GroupStructDevices from "./GroupStructInfoRow/GroupStructDevices"
import GroupStructUsers from "./GroupStructInfoRow/GroupStructUsers"

const GroupDetailComponent = ({ group, refreshData }) => {
	const { user } = useAuth0()

	const renderCondition = useMemo(() => !(isAdmin(user) && process.env.REACT_APP_SAML_ENABLED === "true"), [user, process.env.REACT_APP_SAML_ENABLED])

	const rows = useMemo(
		() => [
			// {
			//     name: "Group Details",
			//     cells: [
			//         {
			//             name: "groupName",
			//             width: 5,
			//             renderCondition: renderCondition,
			//             content: <GroupOrgInfo orgId={group.org_id} />
			//         },
			//         {
			//             name: "Group session info",
			//             width: renderCondition ? 11 : 16,
			//             renderCondition: null,
			//             content: <GroupLastSessionInfo groupId={group.id} />
			//         }
			//     ]
			// },
			{
				name: "Group Structure",
				cells: [
					{
						name: "User List",
						width: 8,
						renderCondition: null,
						content: <GroupStructUsers group={group} refreshData={refreshData} />
					},
					{
						name: "Device List",
						width: 8,
						renderCondition: null,
						content: <GroupStructDevices group={group} refreshData={refreshData} />
					}
				]
			}
		],
		[renderCondition, group]
	)

	return <>{group.id && <BifrostGridForm rows={rows} />}</>
}

export default GroupDetailComponent
